import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { API_URL } from '@/shared/constants/linksApi.js'

// ⚠️ Лучше вынести в .env.local
const API_USER = process.env.API_USER || 'testuser'
const API_PASS = process.env.API_PASS || 'testbtpeel748'

const basicAuth =
  'Basic ' + Buffer.from(`${API_USER}:${API_PASS}`).toString('base64')

export const chatApi = createApi({
  reducerPath: 'chatApi',
  baseQuery: fetchBaseQuery({
    baseUrl: API_URL,
    prepareHeaders: (headers) => {
      headers.set('Content-Type', 'application/json')
      headers.set('Authorization', basicAuth)
      return headers
    },
  }),
  endpoints: (builder) => ({
    addChatQuestion: builder.mutation({
      query: (body) => ({
        url: '/back/chat/add',
        method: 'POST',
        body,
      }),
    }),
    getChatQuestions: builder.mutation({
      query: (token) => ({
        url: '/back/chat/get',
        method: 'POST',
        body: token,
      }),
    }),
  }),
})
